module.exports = __webpack_public_path__ + "static/patricktouchette-23d20c225cd8fa16b49e7e46f9776180.jpg";